import ItemMicrosoftChat from './ItemMicrosoftChat';

export default function WidgetsItemMicrosoftChat({
    position,
    rightIconUrl,
    microsoftChatItemA = {},
}: {
    position: string;
    rightIconUrl?: string;
    microsoftChatItemA: any;
}) {
    if (!microsoftChatItemA) {
        return null;
    }
    return (
        <>
            <ItemMicrosoftChat position={position} microsoftChatItemA={microsoftChatItemA} rightIconUrl={rightIconUrl} />
        </>
    );
}
